import React, { useEffect, useState } from "react";
import Select, { StylesConfig } from "react-select";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../utils/firebase-config";
import { getMTRCategoriesApproved, getMTRPhisicalState } from "../../pages/scraps/scraps-service";
import { PhisicalState } from "../../pages/scraps/scrap-category/models/scrap-category-DTO";

const PhisicalStateEnumInputAutocomplete: React.FC<{
  label: string;
  placeholder: string;
  onChange: (category: any) => void;
  initialValue?: any;
  callHandlerFirstValue?: boolean;
  isDisabled?: boolean;
}> = ({ label, placeholder, onChange, callHandlerFirstValue, initialValue, isDisabled }) => {
  const { t } = useTranslation();
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<any>(
    initialValue || null
  );
  const [inputValue, setInputValue] = useState("");
  const [userId, setUserId] = useState<string>();
  const handleChangeRef = React.useRef(onChange);
  handleChangeRef.current = onChange;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const mtrCategories = await getMTRPhisicalState();

        const options = mtrCategories.map((category: PhisicalState) => ({
          value: category.id,
          label: t(`physicalStateENUM.${category.name}`),
          data: category,
        }));

        setCategoryOptions(options);

        if (initialValue) {
          const initialCategory = options.find(
            (option) => option.value === initialValue.id
          );
          if (initialCategory) {
            if (callHandlerFirstValue) {
              onChange(initialCategory.data)
            }
            setSelectedCategory(initialCategory.data);
            handleChangeRef.current(initialCategory.data);
          }
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchData();
  }, [initialValue, userId]);

  const handleChange = (selectedOption: any) => {
    if (selectedOption && selectedOption.data) {
      setSelectedCategory(selectedOption.data);
      handleChangeRef.current(selectedOption.data);
    } else {
      setSelectedCategory(null);
      handleChangeRef.current(null);
    }
  };

  const handleInputChange = (newValue: string) => {
    setInputValue(newValue);
  };

  const customFilterOptions = (candidate: any, input: string) => {
    return candidate?.label?.toLowerCase().includes(input?.toLowerCase());
  };

  const customStyles: StylesConfig<any, false> = {
    option: (provided, state) => ({
      ...provided,
    }),
  };

  return (
    <div className="" style={{marginTop: "-1rem"}}>
      <div className="">
        <label htmlFor="category">{label}</label>
      </div>
      <div style={{ margin: "0.5rem 0rem" }}>
        <Select
          id="category"
          placeholder={placeholder}
          value={
            selectedCategory
              ? { value: selectedCategory.id, label: t(`physicalStateENUM.${selectedCategory.name}`) }
              : null
          }
          onChange={handleChange}
          onInputChange={(newValue, { action }) => {
            if (action === "input-change") {
              handleInputChange(newValue);
            }
          }}
          options={categoryOptions}
          filterOption={customFilterOptions}
          isDisabled={isDisabled}
          styles={customStyles}
        />
      </div>
    </div>
  );
};

export default PhisicalStateEnumInputAutocomplete;
